import dayjs, { Dayjs } from "dayjs";
import { Activity, DataActivityForm } from "../../../pages/logbook/pages/main/components/shared/formActivity/create/types";
import { ActivityData, DestinationData, UserData } from "../../../pages/logbook/pages/main/components/shared/formActivity/edit/types";
import { Constants } from "../../../utils/constants";
import { ActivityByUserToCreate } from "../response"
import { EvidencesTypeValueEnum } from "../../../utils/enums/evidences";
import { Status } from "../../../utils/enums";



const formatBodyToCreateActivities = ({ usersSelectedInActivity, usersRow }: { usersSelectedInActivity: number[], usersRow: any[] }) => {
    const body: ActivityByUserToCreate[] = usersRow
        .filter(user => usersSelectedInActivity.includes(user.id))
        .map(user => ({
            user_assign: user.id,
            data: user.activities.map((activity: Activity) => ({
                idActivity: activity.id,
                title: activity.name,
                typeActivityId: activity.type ? Number(activity.type.value) : null,
                typeActivityLabel: activity.type ? activity.type.label : null,
                dateEnd: activity.endDate?.format(Constants.dayjsFormat3),
                dateStart: activity.startDate?.format(Constants.dayjsFormat3),
                locationName: activity.destination.direction,
                latitude: String(activity.destination.latitude),
                longitude: String(activity.destination.longitude),
                storeId: activity.destination.id,
                typeDestination: activity.destination.type,
                timeZone: activity.destination.timeZone?.code ?? '',
                activityTypeText: activity.open ? activity.open : null,
                saveInPlaces: activity.destination.toCreate,
                placeId: activity.destination.toCreateSelected ? activity.destination.idDestnation : null,
                namePlace: activity.destination.name,
                companyId: activity.destination.compnayId ?? null
            })),
        }));

    return {
        body
    }
}

const formatBodyToEditActivity = ({ isFree, statusId, userFinal, destinationFinal, dataActivity, defaultValues, evidences, geofence, toCreate }: { toCreate:boolean; isFree: boolean, geofence: boolean, statusId: number, userFinal: UserData | undefined, destinationFinal: DestinationData | undefined, dataActivity: DataActivityForm | undefined, defaultValues: { from?: Dayjs; to?: Dayjs; }, evidences: { [x: string]: { type: EvidencesTypeValueEnum; src: string; name?: string; }[]; } }) => {

    const formattedEvidences = Object.values(evidences).flat().map((evidence) => ({
        evidenceTypeId: evidence.type,
        originalname: evidence.name || "Unknown", // Usa un nombre predeterminado si no hay `name`
        url: evidence.src,
    }));

    const body = {

        title: dataActivity?.title ? String(dataActivity.title) : null,
        userId: userFinal?.id,
        description: dataActivity?.observation ? String(dataActivity.observation) : null,
        typeActivityId: dataActivity?.typeOfActivity ? Number(dataActivity?.typeOfActivity?.value) : null,
        dateStart: (geofence || isFree) ? null : defaultValues.from?.format(Constants.dayjsFormat3),
        dateEnd: (geofence || isFree) ? null : defaultValues.to?.format(Constants.dayjsFormat3),
        locationName: geofence ? null : !destinationFinal?.id ? destinationFinal?.direction : null,
        storeId: geofence ? null : destinationFinal?.id ? destinationFinal.id : null,
        latitude: geofence ? null : String(destinationFinal?.latitude),
        longitude: geofence ? null : String(destinationFinal?.longitude),
        evidences: formattedEvidences,
        activityTypeText: dataActivity?.open ? String(dataActivity.open) : null,
        statusId: (statusId == Status.STARTED && dayjs(defaultValues.from).isAfter(dayjs())) ? Status.TO_BE_STARTED : statusId,
        saveInPlaces: toCreate,
        placeId: destinationFinal?.toCreateSelected ? destinationFinal?.idDestnation : null,
        namePlace: destinationFinal?.name,
        companyId: destinationFinal?.compnayId ?? null,
    }

    return {
        body
    }
}



export { formatBodyToCreateActivities, formatBodyToEditActivity }